<template>
  <b-card class="dashboard-sq-banner-auto justify-content-center text-center" no-body>
    <b-card-body class="d-flex flex-column">
      <slot />
    </b-card-body>
  </b-card>
</template>
<script>
export default {};
</script>
